import {
  SHOW_ALERT,
  DISSMISS_ALERT,
} from '../../actions/alert';

export default function alert(state = {}, action) {
  switch (action.type) {
    case SHOW_ALERT:
      return Object.assign({}, state, action.payload);
    case DISSMISS_ALERT:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alert/index.js